<template>
  <div class="main-header">
    <img class="logo-img" src="../../assets/images/logo.png">
    <el-dropdown v-show="currentUser" class="current-user" @command="handleCommand">
      <div>
        {{currentUser}}<i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  import Utils from "../../utils/utils";
    export default {
        name: 'mainHeader',
        data() {
            return {
                logoUrl: '',
                token: Utils.getLocalStorage('token')
            }
        },
        computed: {
            currentUser() {
                return this.$store.state.currentUser;
            },
        },
        mounted() {
            this.getUserInfo();
        },
        methods: {
            handleCommand() {
                let self = this;
                this.$http.get('/logout', {headers: {'token': this.token}}).then(function (response) {
                    let res = response.data;
                    if (!res || !res.result) {
                        this.$message({
                            message: (res.message) || "退出失败",
                            type: 'error',
                        });
                        return;
                    }
                    Utils.clearLocalStorage('token');
                    self.$store.dispatch('CLEAR_CURRENT_USER');
                    self.$router.push('loginPage');
                }).catch(function (response) {
                    console.log(response);
                });
            },
            login() {
                this.$router.push('loginPage');
            },
            getUserInfo() {
                let self = this;
                this.$http.get('/getUserInfo',
                    {headers: {'token': this.token}}).then(function (response) {
                    let res = response.data;
                    if (res.mdata.userInfo) {
                        self.$store.dispatch('SET_CURRENT_USER', res.mdata.userInfo.name || res.mdata.userInfo.mobilePhone);
                    }
                }).catch(function (response) {
                    console.log(response);
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
  .main-header {
    height: 100%;
    width: 100%;
    overflow: hidden;

    .logo-img {
      height: 56px;
      margin-left: 0px;
    }

    .current-user {
      float: right;
      height: 18px;
      font-size: 16px;
      color: #3596F7;
      margin: 20px 66px;
    }

    .pointer {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/mainHeader.vue